import {
  SET_ALL_MEDIA,
  ALL_MEDIA_CURRENT_PAGE,
  TOTAL_MEDIA_PAGES,
  LOADING_REMOVE_MEDIA,
  REMOVED_MEDIA_ID,
  GET_ALL_GALLERIES,
  ALL_GALLERIES_CURRENT_PAGE,
  TOTAL_GALLERY_PAGES,
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
  allMedia: [],
  mediaTotalPages: 0,
  mediaCurrentPage: 1,
  loadingRemoveMedia: false,
  removedMediaId: "",
  allGalleries: [],
  galleryTotalPages: 0,
  galleryCurrentPage: 1,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ALL_MEDIA: {
      return {
        ...state,
        allMedia: action.payload,
      };
    }
    case TOTAL_MEDIA_PAGES: {
      return {
        ...state,
        mediaTotalPages: action.payload,
      };
    }
    case ALL_MEDIA_CURRENT_PAGE: {
      return {
        ...state,
        mediaCurrentPage: action.payload,
      };
    }
    case LOADING_REMOVE_MEDIA: {
      return {
        ...state,
        loadingRemoveMedia: action.payload,
      };
    }
    case REMOVED_MEDIA_ID: {
      return {
        ...state,
        removedMediaId: action.payload,
      };
    }
    case GET_ALL_GALLERIES: {
      return {
        ...state,
        allGalleries: action.payload,
      };
    }
    case ALL_GALLERIES_CURRENT_PAGE: {
      return {
        ...state,
        galleryCurrentPage: action.payload,
      };
    }
    case TOTAL_GALLERY_PAGES: {
      return {
        ...state,
        galleryTotalPages: action.payload,
      };
    }
    default:
      return state;
  }
};
